import { Button } from "primereact/button";
import React from 'react';

export default ({ history }) => {
	return (
		<div className="card">
			<div className="exception-text">
				<div className="notfound-box">
					<span>404</span>
				</div>
				<span className="notfound-text"> Page Not Found</span>
			</div>
			<div className="exception-panel">
				<div className="exception-image">
					<img src="assets/layout/images/exception/icon-error.png" alt="avalon-react" />
				</div>
				<div className="exception-panel-content">
					<div className="information-text">
						<h3>That wasn’t supposed to happen...</h3>
						<p>Better get back home and forget about that</p>
					</div>
					<Button label="Go Back" onClick={() => { history.go(-2) }} />
				</div>
			</div>
		</div>
	)

}